export const exportHeaders = [
    {
        label: "MPC ID",
        key: "product_primary_class_id"
    },
    {
        label: "MPC Description",
        key: "product_primary_class_description",
    },
    {
        label: "Major Class Code",
        key: "primary_major_class_code",
    },
    {
        label: "Major Class Code Description",
        key: "primary_major_class_code_description",
    },
    {
        label: "Sub Major Class Code",
        key: "primary_submajor_class_code",
    },
    {
        label: "Sub Major Class Code Description",
        key: "primary_submajor_class_code_description",
    },
    {
        label: "Minor Class Code",
        key: "primary_minor_class_code",
    },
    {
        label: "Minor Class Code Description",
        key: "primary_minor_class_code_description",
    },
    {
        label: "Sales Category",
        key: "loyalty_category_code"
    },
    {
        label: "Redemption %",
        key: "redemption_percentage"
    },
    {
        label: "Status",
        key: "is_active"
    },
    {
        label: "Org name",
        key: "loyalty_organization_name"
    },
    {
        label: "Site Name",
        key: "loyalty_site_id"
    },
]
export const exportHeaders_ca = [
    {
        label: "MPC ID",
        key: "product_primary_class_id"
    },
    {
        label: "MPC Description",
        key: "product_primary_class_description",
    },
    {
        label: "Major Class Code",
        key: "primary_major_class_code",
    },
    {
        label: "Major Class Code Description",
        key: "primary_major_class_code_description",
    },
    {
        label: "Sub Major Class Code",
        key: "primary_submajor_class_code",
    },
    {
        label: "Sub Major Class Code Description",
        key: "primary_submajor_class_code_description",
    },
    {
        label: "Minor Class Code",
        key: "primary_minor_class_code",
    },
    {
        label: "Minor Class Code Description",
        key: "primary_minor_class_code_description",
    },
    {
        label: "Sales Category",
        key: "loyalty_category_code"
    },
    {
        label: "Redemption %",
        key: "redemption_percentage"
    },
    {
        label: "Status",
        key: "is_active"
    },
    {
        label: "Allow Points",
        key: "allow_points"
    },
    {
        label: "Allow Tier",
        key: "allow_tier"
    },
    {
        label: "Org name",
        key: "loyalty_organization_name"
    },
    {
        label: "Site Name",
        key: "loyalty_site_id"
    },
]